import axios from "axios";
import Pusher from "pusher-js";
import queryString from "query-string";

let context = {
  arePlayerControlsVisible: false,
  bitrate: 5000,
  bufferSize: 100,
  displayResolution: "1280x720",
  game: "Don't Starve",
  hlsLatencyBroadcaster: 5,
  isFullScreen: false,
  isMuted: false,
  isPaused: false,
  isTheatreMode: false,
  language: "en",
  mode: "viewer",
  playbackMode: "video",
  theme: "light",
  videoResolution: "1280x720",
  volume: 0.5,
};
let contextHandler = null;

const listenCallbacksByTarget = {};
const bitsTransactionCompleteListeners = [];
const bitsTransactionCancelledListeners = [];

function receiveFakePubSub(target, data) {
  const listeners = listenCallbacksByTarget[target] || [];
  listeners.forEach((listener) => listener(null, null, data));
}

export default async function createFakeTwitchHelper() {
  const queryParams = queryString.parse(window.location.search);
  //Pusher.logToConsole = true;
  console.log("Initializing fake Twitch helper.");

  const { channel_id, user_id, role, is_linked } = {
    user_id: queryParams.user_id || "DEBUG_USER",
    channel_id: queryParams.channel_id || "DEBUG_CHANNEL",
    role: queryParams.role || "viewer",
    is_linked: queryParams.is_linked ? queryParams.is_linked === "true" : true,
  };

  // Get fake auth token and create response
  const { data: tokenData } = await axios.post(
    `${process.env.DEV_EBS_API_BASE_URL}/auth/token`,
    {
      user_id,
      channel_id,
      role,
    }
  );

  const pusher = new Pusher(process.env.FAKE_TWITCH_PUBSUB_PUSHER_KEY, {
    cluster: "eu",
  });

  const channel = pusher.subscribe(channel_id);
  channel.bind("broadcast", function (data) {
    receiveFakePubSub("broadcast", JSON.stringify(data));
  });

  return {
    receiveFakePubSub: receiveFakePubSub,
    listen: (target, callback) => {
      if (!listenCallbacksByTarget[target]) {
        listenCallbacksByTarget[target] = [];
      }

      listenCallbacksByTarget[target].push(callback);
    },
    onAuthorized: (fn) => {
      fn({
        channelId: channel,
        userId: user_id,
        token: tokenData.token,
      });
    },
    updateContext: (updatedContext) => {
      if (contextHandler) {
        context = { ...context, ...updatedContext };
        contextHandler(context);
      }
    },
    onContext: (fn) => {
      contextHandler = fn;
      fn(context);
    },
    viewer: {
      isLinked: is_linked,
      role,
    },
    actions: {
      requestIdShare: () => {
        console.log("TODO: implement");
      },
    },
    features: {
      isBitsEnabled: true,
    },
    bits: {
      getProducts: () => [
        {
          cost: {
            amount: 100,
            type: "bits",
          },
          displayName: "Premium Skin - 100 Bits",
          sku: "PREMIUM_SKIN_100_BITS",
          inDevelopment: true,
        },
        {
          cost: {
            amount: 250,
            type: "bits",
          },
          displayName: "Premium Skin - 250 Bits",
          sku: "PREMIUM_SKIN_250_BITS",
          inDevelopment: true,
        },
      ],
      setUseLoopback: () => {},
      onTransactionComplete: (handler) =>
        bitsTransactionCompleteListeners.push(handler),
      onTransactionCancelled: (handler) =>
        bitsTransactionCancelledListeners.push(handler),
      useBits: (sku) => {
        const fakeTransaction = { transactionId: "FAKE_TRANSACTION_ID" };

        bitsTransactionCompleteListeners.forEach((listener) => {
          listener(fakeTransaction);
        });
      },
    },
  };
}
